import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses }  from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default function ReviewUploadContact({contactArray}) {
  return (
    <TableContainer component={Paper}
    sx={{
      border: "1px solid black",
      padding: 1,
      backgroundColor: "#ebebeb"
    }}
    >
      <Table
        sx={{ minWidth: 650 }}
        aria-label="simple table"
        sx={{
          [`& .${tableCellClasses.root}`]: {
            borderBottom: "none"
          }
        }}
        size='small'
      >
        <TableHead>
          <TableRow
            sx={{
              borderBottom: "1px solid black",
              "& th": {
              color: "rgba(96, 96, 96)"
              }
            }}
          >
            <TableCell>Nama</TableCell>
            <TableCell>Nomor Telepon</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Keterangan</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {contactArray.slice(0,5).map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell>{row.number}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.desc}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}